import { Suspense, lazy, useMemo, useState } from "react";
import {
  COACH_REFERENCE_DOC,
  TABLIST,
  TABLIST_ARRAY,
  TABLIST_TEXT_MAPPING,
} from "./constant";
import useFetchUserDataToShowRingStats from "../../../utils/hooks/useFetchUserData";
import styles from "./RingDetails.module.css";

const components: any = {
  UserProfile: () => import("./UserProfile"),
  VitalDetails: () => import("./VitalDetails"),
  SleepDetails: () => import("./SleepDetails"),
  ActivityDetails: () => import("./ActivityDetails"),
  CalorieDetails: () => import("./CalorieDetails"),
  StressDetails: () => import("./StressDetails"),
  Vo2Max: () => import("./Vo2Max"),
};

const withLazyLoad = (Component: any) => (props: any) => {
  const LazyComponent = lazy(Component);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

const LazyLoadedComponents = Object.keys(components).reduce(
  (acc: any, key: any) => {
    acc[key] = withLazyLoad(components[key]);
    return acc;
  },
  {}
);

const {
  UserProfile,
  VitalDetails,
  SleepDetails,
  ActivityDetails,
  CalorieDetails,
  StressDetails,
  Vo2Max,
} = LazyLoadedComponents;

const RingDetailsComponent = () => {
  const userData = useFetchUserDataToShowRingStats();
  const [currentTab, setCurrentTab] = useState(TABLIST.USER_PROFILE);

  const handleTabChange = (e: React.MouseEvent<HTMLDivElement>) => {
    const targetElement = e.currentTarget as HTMLDivElement;
    e.stopPropagation();
    if (!targetElement) {
      return;
    }
    const tab = targetElement.getAttribute("data-tab");
    if (!tab) return;

    setCurrentTab(tab);
  };

  const renderTabList = useMemo(() => {
    return TABLIST_ARRAY.map((tab: string) => {
      return (
        <div className={styles.tabListBtnWrapper}>
          <div
            className={`${styles.tabListBtn} ${
              currentTab === tab ? styles.tabListActiveBtn : ""
            }`}
            data-tab={tab}
            key={tab}
            onClick={handleTabChange}
          >
            {TABLIST_TEXT_MAPPING[tab]}
          </div>
          {currentTab === tab && <div className={styles.bottomListActiveBtn} />}
        </div>
      );
    });
  }, [currentTab]);

  const renderCurrentTabComponent = () => {
    switch (currentTab) {
      case TABLIST.USER_PROFILE:
        return <UserProfile data={userData} />;
      case TABLIST.VITALS:
        return <VitalDetails />;
      case TABLIST.SLEEP:
        return <SleepDetails />;
      case TABLIST.ACTIVITY:
        return <ActivityDetails />;
      case TABLIST.CALORIES_BALANCE:
        return <CalorieDetails />;
      case TABLIST.STRESS:
        return <StressDetails />;
      case TABLIST.VO2MAX:
        return <Vo2Max />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <div className={styles.headerTextWrapper}>
        {userData && userData?.fullName && <h2>{userData?.fullName}'s data</h2>}
        <button
          className="btn btn-outline-secondary"
          onClick={() => window.open(COACH_REFERENCE_DOC)}
        >
          Coach Reference doc
        </button>
      </div>
      <div className={styles.tabListWrapper}>{renderTabList}</div>
      <div className={styles.contentWrapper}>{renderCurrentTabComponent()}</div>
    </>
  );
};

export default RingDetailsComponent;
